export default __webpack_public_path__ + "static/tatamemorialcentre-9ac9f582294625290c860e4143ff23dc.png";